import React, { Component } from "react";
import Slider from "react-slick";

export default class Carousel extends Component {
  render() {
    const settings = {
      speed: 700,
      slidesToShow: 3,
      slidesToScroll: 3,
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            initialSlide: 1,
          },
        },
      ],
    };
    return (
      <div className="my-8">
        <Slider {...settings}>
          <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/Portfolio/novamuta.png")}
                alt="portfolio"
              />
            </div>
            <div className="card-text">
              <h1 className="card-title">NovaMuta Virtual Event</h1>
              <p className="card-description">
                This is a thesis project about virtual event gamification
                developed using HTML, CSS, Bootstrap, PHP and MySQL.
              </p>
            </div>
          </div>
          <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/Portfolio/serenity.jpg")}
                alt="portfolio"
              />
            </div>
            <div className="card-text">
              <h1 className="card-title">Serenity Kingdom</h1>
              <p className="card-description">
                A project that was developed during the internship at Shinta VR
                using HTML, CSS, Bootstrap, Node.js and Firebase.
              </p>
            </div>
          </div>
          <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/Portfolio/millealab-ambasador.jpg")}
                alt="portfolio"
              />
            </div>
            <div className="card-text">
              <h1 className="card-title">Some of the Millealab Website</h1>
              <p className="card-description">
                Adding several features on Millealab website using PHP
                Codeigniter, HTML, CSS, Bootstrap and MySQL.
              </p>
            </div>
          </div>
          <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/Portfolio/faculty-landing-page.png")}
                alt="portfolio"
              />
            </div>
            <div className="card-text">
              <h1 className="card-title">Faculty Landing Page</h1>
              <p className="card-description">
                A freelance project to build a faculty website using HTML, CSS
                and TailwindCSS.
              </p>
            </div>
          </div>
          <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/Portfolio/dakge.png")}
                alt="portfolio"
              />
            </div>
            <div className="card-text">
              <h1 className="card-title">Dakge</h1>
              <p className="card-description">
                This is a website to introduce Dakge products using HTML, CSS
                and JavaScript.
              </p>
            </div>
          </div>
          <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/Portfolio/andayasa-dwicipta.png")}
                alt="portfolio"
              />
            </div>

            <div className="card-text">
              <h1 className="card-title">Andayasa Dwicipta</h1>
              <p className="card-description">
                This is a Landing Page to introduce PT Andayasa Dwicipta
                services using React.js with TailwindCSS as a CSS Style.
              </p>
            </div>
          </div>
          <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/Portfolio/trova-visuals.png")}
                alt="portfolio"
              />
            </div>

            <div className="card-text">
              <h1 className="card-title">Trova Visuals</h1>
              <p className="card-description">
                This is a Landing Page to introduce the Portfolio and Services
                from Trova Visuals using React.js with TypeScript and
                TailwindCSS as a CSS Style.
              </p>
            </div>
          </div>
          {/* <div className="card-item">
            <div className="card-image">
              <img
                src={require("Assets/Images/portfolio.png")}
                alt="portfolio"
              />
            </div>
            <div className="card-text">
              <h1 className="card-title">Judul Project 6</h1>
              <p className="card-description">
                a short description project and detail tech to developed this
                project e.g (HTML, CSS, Tailwind CSS)
              </p>
            </div>
          </div> */}
        </Slider>
      </div>
    );
  }
}
